import { Container } from "../components/common-components";
import { FormHeader } from "../components/FormHeader";
import { FormFooter } from "../components/FormFooter";
import { ServiceInfo } from "../components/ServiceInfo";
import { InterventionPatientSections } from "./components/InterventionPatientSections";
import { DetailsSection } from "./components/DetailsSection";
import { PharmacyFollowup } from "./components/PharmacyFollowup";
import { PatientInformation } from "../components/PatientInformation";
import { PatientContactInformation } from "../components/PatientContactInformation";
import { LabInformation } from "./components/LabInformation";
import { PrescriberSuggestionSection } from "./components/PrescriberSuggestionSection";
import { PrescribingPharmacistInformation } from "../components/PrescribingPharmacistInformation";
import { ReferralsAndNotifications } from "../components/ReferralsAndNotifications";
import { AllergyInformation } from "../components/AllergyInformation";
import { PharmacyUseOnly } from "./components/PharmacyUseOnly";

export const InterventionsDocumentationForm = ({
  ref = null,
  formType = "intervention",
  patient = {},
  preAssessment = {},
  clinicalAssessment = {},
  clinicalServiceName = "MedicationReview",
  clinicalServiceTypeCode = "",
  startDateTime = new Date().toISOString(),
  endDateTime = new Date().toISOString(),
  documentation = {},
  interventionDetails = {},
  interventionType = null,
  intervention = null,
  pharmacistFollowUp = {},
  prescriberFollowUp = {},
}) => {
  return (
    <Container>
      <FormHeader formType={formType} />
             <div className="mx-4 mt-1">
               <div className="[&>*]:!border-0 [&>*]:!shadow-none [&>*]:!border-t-0 [&>*]:!border-b-0 [&>*]:!border-l-0 [&>*]:!border-r-0">
                 <ServiceInfo 
                   referral={null} 
                   isReferral={false} 
                   startDateTime={startDateTime}
                   isInterventionForm={true}
                 />
               </div>
              <InterventionPatientSections
                clinicalServiceName={clinicalServiceName}
                documentation={documentation}
                intervention={intervention}
              />
               
               <div className="flex bg-gray-10 border border-gray-100 border-t-0">
                 <div className="flex-1 py-0">
                   <PatientInformation formType={formType} patient={patient} preAssessment={preAssessment} />
                 </div>
                 <div className="w-px bg-gray-200 my-4"></div>
                 <div className="flex-1 py-0">
                   <PatientContactInformation formType={formType} patient={patient} />
                 </div>
               </div>
               
              <AllergyInformation formType={formType} patient={patient} clinicalAssessment={clinicalAssessment} namesOnly />
              <DetailsSection
                formType={formType}
                interventionDetails={interventionDetails}
                interventionType={interventionType}
                clinicalServiceName={clinicalServiceName}
                clinicalServiceTypeCode={clinicalServiceTypeCode}
                intervention={intervention}
              />
              <PharmacyFollowup formType={formType} pharmacistFollowUp={pharmacistFollowUp} />
              <LabInformation formType={formType} pharmacistFollowUp={pharmacistFollowUp} />
              <PrescriberSuggestionSection
                formType={formType}
                prescriberSuggestions={prescriberFollowUp?.prescriberSuggestions || ""}
                pharmacistRxChangeComments={prescriberFollowUp?.pharmacistSuggestions}
                suggestFollowUpAppointment={
                  prescriberFollowUp?.suggestFollowUp === true ||
                  prescriberFollowUp?.suggestFollowUp === "true"
                }
              />
    
              <PrescribingPharmacistInformation formType ={formType} startDateTime={startDateTime} endDateTime={endDateTime} />
              <ReferralsAndNotifications formType={formType} documentation ={documentation} />
              <PharmacyUseOnly formType={formType} />
              <FormFooter />
            </div>
    </Container>
  );
};